export const get_session_transaction_query = `
  query Get_session_transaction {
    transaction {
        status
        trace_id
        currency
        amount
        transaction_id
        payment_processor
        error_message
        charge_amount
        charge_currency
        payment_method
        message
        descriptor
        created_at
        fee_amount
        card_brand
        promocode_title
        card_number
        transaction_type
        new_attempt
        new_attempt_same_details
        processing_in_progress
        submit_action
        submit_name
        ob_decline_recovery
        ob_additional_fields_filled
        retry_with_apm
        is_crypto
        show_reject_reason
        retry_settings {
          fees
          payment_information {
            base_currency
            crypto
            currency_list
            max_amount
            min_amount
            rate
            spread_rate
          }
          show_amount_field
          predefined_options {
            amount
            currency
          }
        }
    }
  }
`;